import ActionMenu from "@/v2-backoffice-client/components/actionMenu"
import FeatureRenameMenuItem from "@/v2-backoffice-client/feature/rename/FeatureRenameMenuItem"
import type { LayerFragment } from "@/v2-backoffice-client/layer/__types__/layer.fragment"
import LayerEnableMenuItem from "@/v2-backoffice-client/layer/enable/LayerEnableMenuItem"

export type LayerActionMenuProps = {
  layer: LayerFragment
  /**
   * Requests the rename dialog. The dialog is owned by the TABLE, not this
   * menu: the row toolbar only exists while its row is hovered or holds an
   * open menu, so anything mounted here dies the moment the menu closes.
   */
  onRename(): void
}

function LayerActionMenu(props: LayerActionMenuProps) {
  const { layer, onRename } = props

  return (
    <ActionMenu>
      <ActionMenu.Trigger />

      <ActionMenu.Content>
        <LayerEnableMenuItem layer={layer} />
        <FeatureRenameMenuItem
          dataFeatureCode="UI_BackofficeLayers_Rename_MenuItem"
          onSelect={onRename}
        />
      </ActionMenu.Content>
    </ActionMenu>
  )
}

export default LayerActionMenu
